function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 3");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: 4.01,
  transform: "translate(-1309.000000, -42.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(1309.000000, 42.000000)"
}, React.createElement("path", {
  d: "M19.2426407,20.1213202 L19.2426407,9.87867966 C20.9108387,11.1893398 21.9426407,12.9999999 21.9426407,14.9999999 C21.9426407,16.9999999 20.9108387,18.81066 19.2426407,20.1213202 Z M5.65625,8.5625 L14.625,0 L14.625,30 L5.65625,21.4375 L-2.58637556e-12,21.4375 L-2.58637556e-12,8.5625 L5.65625,8.5625 Z M24.1268597,29.5205808 L20.8731403,24.4794192 C24.6070707,22.0694266 26.3571429,19.0068004 26.3571429,15 C26.3571429,10.9931996 24.6070707,7.93057336 20.8731403,5.52058078 L24.1268597,0.47941922 C29.5357864,3.97050551 32.3571429,8.90787923 32.3571429,15 C32.3571429,21.0921208 29.5357864,26.0294945 24.1268597,29.5205808 Z",
  id: "Combined-Shape"
})))));

var SvgSoundOn = function SvgSoundOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 33 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSoundOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-on.4157b908.svg";
export { ForwardRef as ReactComponent };